<template>
  <div class="tw-flex tw-flex-col tw-gap-4 tw-mb-4">
    <div class="tw-flex tw-gap-2 tw-items-center">
      <h2 class="tw-mb-0 tw-font-semibold tw-text-xl">
        {{ $t("threat-coach-tab") }}
      </h2>
      <cl-pill :variant="'infoFull'" :uppercase="false">
        <div class="tw-flex tw-items-center tw-gap-1">
          Powered by AI
          <cb-icon-ai :width="20" :height="20" />
        </div>
      </cl-pill>
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  email?: string;
};

defineProps<Props>();
</script>
